/** Marcador de campo sem valor a exibir: travessão, nunca string vazia nem "Não". */
export const TRACO = '—';
